import ModalActionsCodesHistories from './ModalActionsCodesHistories'
export default ModalActionsCodesHistories
